import React from 'react';
import PropTypes from 'prop-types';
import {
  DoorImageWrapper,
  DoorText,
} from './styled/AdventCalendar';
import DoorSvg from './elements/DoorSvg';

export default class DoorImageContainer extends React.Component {
  render() {
    const {
      number,
      backgroundImg,
      imageType,
      borderColor,
      backgroundColor,
      textColor,
      top,
      left,
      doorSize,
      doorClickAction,
      isMobile,
    } = this.props;

    return (
      <DoorImageWrapper className="adventcalendar__door" top={top} left={left} isMobile={isMobile} doorSize={doorSize}>
        <div className="door-img-wrapper">
          <a className="adventcalendar__door-link" href={`#adventcalendar-dialog-${number}`} data-number={number} onPointerDown={doorClickAction} onMouseDown={doorClickAction} onClick={doorClickAction}>
            {imageType !== 'preselection' && <img src={backgroundImg} alt="door-background" />}
            {imageType === 'preselection' && (
              <DoorSvg
                url={backgroundImg}
                doorSize={doorSize}
                background={backgroundColor}
                border={borderColor}
                width={doorSize}
              />
            )}
            <DoorText textColor={textColor} textSize={doorSize / 2} className="adventcalendar__door-text">{number}</DoorText>
          </a>
        </div>
      </DoorImageWrapper>
    );
  }
}

DoorImageContainer.propTypes = {
  number: PropTypes.number.isRequired,
  backgroundImg: PropTypes.string.isRequired,
  imageType: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  doorSize: PropTypes.number.isRequired,
  doorClickAction: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
